// extracted by mini-css-extract-plugin
module.exports = {"discountList":"discount-list_discountList__3w-Bh","prevArrow":"discount-list_prevArrow__gJDom","nextArrow":"discount-list_nextArrow__27vqM"};